export enum EventTypes {
  Event = 'submitEvent', /*                           */
  Move = 'submitMove',
  PageImpression = 'addToPageImpression', /*                                                                                  */
}
